import { render, staticRenderFns } from "./ModernDimensionBoostRow.vue?vue&type=template&id=70fb84dc"
import script from "./ModernDimensionBoostRow.vue?vue&type=script&lang=js"
export * from "./ModernDimensionBoostRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports